<script lang="ts">
import { computed, defineComponent } from 'vue';
import ItemGroup from '@/src/components/ItemGroup.vue';
import { useDICOMStore } from '@/src/store/datasets-dicom';
import { useCurrentImage } from '@/src/composables/useCurrentImage';
import { isDicomImage, selectionEquals } from '@/src/utils/dataSelection';
import { useViewStore } from '@/src/store/views';
import PatientStudyVolumeBrowser from './PatientStudyVolumeBrowser.vue';

export default defineComponent({
  name: 'SeriesModule',
  components: { ItemGroup, PatientStudyVolumeBrowser },
  setup() {
    const dicomStore = useDICOMStore();
    const viewStore = useViewStore();
    const { currentImageID } = useCurrentImage();

    // Chỉ liệt kê khối của ĐÚNG ca đang mở.
    // Không dùng lại DataBrowser của VolView gốc: nó kèm "Sample Data", nút "Delete Patient" và
    // trình duyệt DICOMweb — thứ cuối cho phép lần sang bệnh nhân khác ngay trong khung xem.
    const volumeKeys = computed(() => {
      const hienTai = currentImageID.value;
      const studyKey =
        hienTai && isDicomImage(hienTai) ? dicomStore.volumeStudy[hienTai] : '';
      if (studyKey) return [...(dicomStore.studyVolumes[studyKey] ?? [])].sort();
      // Chưa chọn khối nào (đang tải) -> liệt kê tất cả những gì đã nạp.
      return Object.values(dicomStore.studyVolumes).flat().sort();
    });

    function setViewImage(imageID: string) {
      viewStore.setDataForActiveView(imageID);
    }

    return { volumeKeys, currentImageID, selectionEquals, setViewImage };
  },
});
</script>

<template>
  <!-- item-group là BẮT BUỘC: mỗi ô khối bên trong là một GroupableItem, thiếu nó thì Vue ném
       "GroupableItem needs ItemGroup!" cho từng ô và bấm vào khối cũng không đổi được ảnh. -->
  <item-group
    :model-value="currentImageID"
    :equals-test="selectionEquals"
    @update:model-value="setViewImage"
  >
    <div class="mx-1 fill-height">
      <patient-study-volume-browser :volume-keys="volumeKeys" />
      <div v-if="volumeKeys.length === 0" class="ma-4 text-center text-caption">
        Chưa nạp được ca nào.
      </div>
    </div>
  </item-group>
</template>
